export default __webpack_public_path__ + "static/media/acdelco.ea1fe0d7.png";